export const getMediaPath = (path: string) => {
    return process.env.REACT_APP_MEDIA_URI + '/' + path;
};